<template>
  <Modal :show="show" @close="$emit('close')">
    <template v-slot:body>
      <div class="items">
        <div class="item" v-for="(result, i) in results" :key="i">
          <template v-if="result.genre === 'pokemon'">
            <template v-if="result.productType === 'single'">
              <div class="productName">{{ getPokemonSingleProductInfoString(result.product) }}</div>
              <div class="inventories">
                <template v-for="inventory in sortByRank(result.inventories)" :key="inventory.inventoryId">
                  <div class="inventory" v-for="message in inventory.messages" :key="message">[状態{{ inventory.rank.toUpperCase() }}] {{ message }}</div>
                </template>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <Button
        :text="`確認して${mode === 'cart' ? 'カート' : '注文'}へ戻る`"
        style="width: 100%"
        @click="$emit('close')"
      />
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineNuxtComponent, useNuxtApp } from '#app'
import { Modal, Button } from '@ka-nabellinc/ka-nabell-ui'
import type { NormalizedAvailabilityValidationResult } from '@/types/order'
import { getPokemonSingleProductInfoString } from '@/utils/pokemon'
import { sortByRank } from '@/utils/product'

export default defineNuxtComponent({
  components: {
    Modal,
    Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    results: {
      type: Array as () => NormalizedAvailabilityValidationResult[],
      default: []
    },
    mode: {
      type: String as () => 'cart' | 'order',
      default: 'cart'
    }
  },
  emits: ['close'],
  setup(props) {
    return {
      sortByRank,
      getPokemonSingleProductInfoString
    }
  }
})
</script>

<style scoped>
.items {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.productName {
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.15px;
}

.inventory {
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.15px;
}
</style>
